"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteTitle = void 0;
const react_1 = __importDefault(require("react"));
const SiteTitle = ({ title }) => {
    return (react_1.default.createElement("span", { className: "ml-4 border-l-4 border-grey-2 pl-4 font-display text-lg font-bold uppercase\n            leading-none tracking-[1.56px] text-secondary sm:pl-5 md:text-xl lg:text-[26px]" }, title));
};
exports.SiteTitle = SiteTitle;
